import Parse from 'parse';
import {ModelYear,YoutubeApiKey} from './constants';
export const ProductAssetUrl = "https://assets.hosports.com/"+ModelYear+"/img/";
export const ResizeableProductAssetUrl = "https://assets.hosports.com/image.php?src="+ModelYear+"/img/";
import {GetFromParseBySlug, FindFromParse} from './parse';
import Axios from 'axios';

export const BaseUrl = () =>{
  /*
  if international
  let url = window.location.pathname.split('/');
  if(url[1]){
    return '/'+url[1]+'/'
  } else{
    return '/'
  }
  */
  return '/'
};

export const SetupSiteText = async() =>{
  const SiteTextQuery = Parse.Object.extend("SiteText");
  const sitetextquery = new Parse.Query(SiteTextQuery);
  sitetextquery.limit(10000)
  const siteTextResults = await sitetextquery.find();
  var siteText = {};
  window.siteTextResults = siteTextResults;
  for (var i = 0; i < siteTextResults.length; i++) {
    let data = siteTextResults[i]
    siteText[data.attributes.slug] = {};
    var content = {};
    data.attributes.content.map((item,index)=>{
      content[item.lang]=item.title;
      if(index == data.attributes.content.length -1){
        siteText[data.attributes.slug] = content;
      }
    })
  }
  window.siteText = siteText;
  return true;
}

export const SetupSeo = async() =>{
  const SeoQuery = Parse.Object.extend("Seo");
  const seoquery = new Parse.Query(SeoQuery);
  seoquery.equalTo('site',window.site);
  seoquery.limit(1000)
  const seoresults = await seoquery.find();
  var seo = {};
  for (var i = 0; i < seoresults.length; i++) {
    var data = seoresults[i];
    seo[data.attributes.url] = data;
  }
  window.seo = seo;
  return true;
}

export const SetupProducts = async() =>{
  const ProductQuery = Parse.Object.extend("Products"+ModelYear);
  const productquery = new Parse.Query(ProductQuery);
  productquery.equalTo('site',window.site);
  productquery.limit(1000)
  const productResults = await productquery.find();
  window.productDictionary = {};
  window.products = productResults;
  for (var i = 0; i < productResults.length; i++) {
    window.productDictionary[productResults[i].id] = productResults[i];
  }
  return true
}

export const SetupRedirects = async() =>{
  if(window.location.pathname.indexOf('product-detail') != -1){
      var slug = window.location.search.replace('?id=','');
      window.location.assign('product/'+slug)
  }
  return true
}

export const SetupSubcategories = async() =>{
  const SubcategoryQuery = Parse.Object.extend("Subcategories");
  const subcategoryquery = new Parse.Query(SubcategoryQuery);
  subcategoryquery.equalTo('site',window.site);
  subcategoryquery.ascending('order')
  const subcategoryResults = await subcategoryquery.find();
  window.subcategoryDictionary = {};
  window.subcategories = subcategoryResults;
  for (var i = 0; i < subcategoryResults.length; i++) {
    window.subcategoryDictionary[subcategoryResults[i].id] = subcategoryResults[i];
  }
  return true;
}

export const SetupTeam = async() =>{
  const TeamQuery = Parse.Object.extend("Team"+ModelYear);
  const teamquery = new Parse.Query(TeamQuery);
  teamquery.equalTo('site',window.site);
  teamquery.equalTo('visibility',true);
  teamquery.ascending('order')
  teamquery.limit(1000)
  const teamResults = await teamquery.find();
  window.teamDictionary = {};
  window.team = teamResults;
  for (var i = 0; i < teamResults.length; i++) {
    window.teamDictionary[teamResults[i].id] = teamResults[i];
  }
  return true
}

export const GetSubcategoriesFromCategory = async (category) => {
  var subcategories = window.subcategories.filter(subcategory => subcategory.attributes.parent && subcategory.attributes.parent == category);
  return subcategories;
}

export const GetProductBySlug = async (slug) => {
  var products = window.products.filter(product => product.attributes.slug == slug);
  return products[0];
}

export const GetProductsByQuery = async (key,value,limit) => {
  let lang = window.lang;
  if(window.lang == 'eu'){
    lang = "de"
  }
  let products = window.products.filter(product => product.attributes[key] == value && product.attributes.locale.indexOf(lang) != -1);
  let results = products;
  if(products && limit){
    results = products.slice(0,limit)
  }
  return results;
}

export const GetProductsByCollection = async (collection) => {
  let products = window.products.filter(product => product.attributes.collections && product.attributes.collections.indexOf(collection) != -1);
  return products;
}
export const GetProductsByCategory = async (category) => {
  let products = window.products.filter(product => product.attributes.category && product.attributes.category == category);
  return products;
}

export const GetProductsBySubCategory = async (subcategory) => {
  let products = window.products.filter(product => product.attributes.subcategory && product.attributes.subcategory == subcategory);
  return products;
}

export const ReorderProducts = async (products) => {
  var sortedProducts = products.sort(compare);
  return sortedProducts;

  function compare(a, b){
    return a.attributes.order - b.attributes.order;
  }
}

export const GetProductsBySlugs = async (slugs) => {
  var products = window.products.filter(product => slugs.indexOf(product.attributes.slug) != -1);
  return products;
}

export const GetTeamByType = async (type) => {
  var Team;
  if(type == 'wakeboard'){
    Team = window.team;
  }
  if(type == "Ski"){
    Team = window.team.filter(rider => rider.attributes.team == "Ski");
  } else if (type == "Wake/Knee"){
    Team = window.team.filter(rider => rider.attributes.team == "Wake/Knee");
  }
  return Team;
}

export const GetRidersBySlugs = async (slugs) => {
  var riders = window.team.filter(rider => slugs.indexOf(rider.attributes.slug) != -1);
  return riders;
}
export const GenerateProductAssetUrl = (year) =>{
  let url = 'https://assets.hosports.com/'+ModelYear+'/img/';
  if(year){
    url = 'https://assets.hosports.com/'+year+'/img/';
  }
  return url
}
export const OrderProductsByPrice = async (products) => {
  var sortedProducts = products.sort(compare);
  return sortedProducts;
  function compare(a, b){
    if(b.attributes.content[0].price && a.attributes.content[0].price){
      return parseFloat(b.attributes.content[0].price.toString().replace(',','')) - parseFloat(a.attributes.content[0].price.toString().replace(',',''))
    } else{
      return false
    }
  }
}

export const ReturnProductDetailLink = async (product) => {
  /*
  if(product.attributes.msftRecordIdMap){
    let keys = Object.keys(product.attributes.msftRecordIdMap)
    return '/hl/'+product.attributes.slug+'/'+product.attributes.msftRecordIdMap[keys[0]]+'.p';
  } else{
    return ''
  }
  */
  if(window.location.search){
    return '/product/'+product.attributes.slug+window.location.search
  } else{
    return '/product/'+product.attributes.slug
  }
}

export const ReturnLocalizedLink = async (url) => {
  if(window.location.search){
    let baseUrl = await BaseUrl();
    return baseUrl+url+window.location.search.replace('?','&')
  } else{
    return baseUrl+url
  }
}


export const GetUrlVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

export const getCookieValue = (a) => {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

export const GetLocalizedText = (content,target) =>{
  var text;
  //var lang = window.lang;
  var lang = 'en';
  if(content){
    content.map((data,index) => {
      if(data.lang == 'en'){
        text = data[target]
      }
      if(data.lang == lang && data[target]){
        if(data[target] != "" && data[target] != " "){
          text = data[target];
        }
      }
      if(index == content.length -1){
        return text;
      }
    })
  }
  return (text);
}

export const GetLocalText = async (slug) => {
  let text = await GetFromParseBySlug('SiteText',slug)
  if(text){
    let localizedText = await GetLocalizedText(text.attributes.content,'title');
    if(localizedText){
      return localizedText
    } else{
      return '';
    }
  } else{
    return '';
  }
}

export const GetLocalizedPrice = async (content,target) => {
  var price = '';
  var lang = window.lang;
  if(window){
    if(window.location){
      if(window.location.href){
        if(window.location.href.indexOf('fatsac.com') != -1 || window.location.href.indexOf('barefootinternational.com') != -1){
          lang = "en"
        }
      }
    }
  }
  console.log(lang)
  var englishPrice = "";
  content.map((data,index) => {
    if((lang == 'en' && data.lang == 'en')){
      price = '$'+data['price'];
      englishPrice = '$'+data['price'];
    }
    if(lang == 'fr' && data.lang == 'fr'){
      var flag = true;
      if(data['price'] != "" && data['price'] != " " && data['price'] != null){
        price = '$'+data['price']+' CAD';
      }
    }
    if(lang == 'ca-fr' && data.lang == 'ca-fr'){
      var flag = true;
      if(data['price'] != "" && data['price'] != " " && data['price'] != null){
        price = '$'+data['price']+' CAD';
      }
    }
    if(lang == 'ca-en' && data.lang == 'ca-en'){
      var flag = true;
      if(data['price'] != "" && data['price'] != " " && data['price'] != null){
        price = '$'+data['price']+' CAD';
      }
    }

    if(lang == 'au' && data.lang == 'au'){
      if(data['price'] != "" && data['price'] != " " && data['price'] != null){
        price = '$'+data['price']+' AUD';
      }
    }
    if(lang == 'de' && data.lang == 'de'){
      if(data['price'] != "" && data['price'] != " " && data['price'] != null){
        price = '€'+data['price'];
      }
    }
    if(lang == 'uk' && data.lang == 'uk'){
      if(data['price'] != "" && data['price'] != " " && data['price'] != null){
        price = '£'+data['price'];
      }
    }
    if(lang == 'eu' && data.lang == 'eu'){
      if(data['price'] != "" && data['price'] != " " && data['price'] != null){
        price = '€'+data['price'];
      }
    }
    if(index == content.length -1){
      return price;
    }
  })
  return price;
}


export const ShuffleArray = (a) => {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
  }
  return a;
}

export const StripHtml = (html) =>{
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent.replace(/(\r\n|\n|\r)/gm, "") || tmp.innerText.replace(/(\r\n|\n|\r)/gm, "") || "";
}

export const RemoveLoading = () =>{
  let loader = document.getElementById('loading');
  setTimeout(()=>{
    loader.parentNode.removeChild(loader)
  }, 750);
  loader.style.opacity = '0';
}

export const GetExternalProductId = async(data) =>{
  if(data.productSpecificationData){
    return data.productSpecificationData.then((specs) => {
      let slug = null;
      for (let index = 0; index < specs.length; index++) {
        if(specs[index].Name === "ExternalItemId"){
          slug = specs[index].TextValue;
        }
      }
      return slug;
    });
  } else{
    return null
  }
}

export const GetThumbnailFromVimeo = async(url) =>{
  let thumbnail = null;
  if(url){
    let response = await Axios.get('https://vimeo.com/api/oembed.json?url='+url);
    console.log(response)
    if(response){
      if(response.data){
        thumbnail = response.data.thumbnail_url
      }
    }
  }
  return thumbnail
}

export const DoesProductShowDetailImages = async(product,category,subcategory) =>{
  let value = false;
  if(category){
    if(category.attributes.showProductDetailImages){
      value = true
    }
  }
  if(subcategory){
    if(subcategory.attributes.showProductDetailImages){
      value = true
    }
  }
  if(product){
    if(product.attributes.showProductDetailImages){
      value = true
    }
  }
  return value
}

export const DoesProductShowHeroImage = async(product,category,subcategory) =>{
  let value = false;
  if(category){
    if(category.attributes.showProductHeroImage){
      value = true
    }
  }
  if(subcategory){
    if(subcategory.attributes.showProductHeroImage){
      value = true
    }
  }
  if(product){
    if(product.attributes.showProductHeroImage){
      value = true
    }
  }
  return value
}

export const GetYoutubeIdFromUrl = async(youtubeUrl) =>{
  let videoId = null;
  if(youtubeUrl){
    videoId = youtubeUrl.split('v=')[1];
    if(videoId){
      let ampersandPosition = videoId.indexOf('&');
      if(ampersandPosition != -1) {
        videoId = videoId.substring(0, ampersandPosition);
      }
    }
  }
  return videoId
}

export const GetProductFromItemNumber = async (itemNumber,year) =>{
  let prodModelYear = year ? year : ModelYear;
  if(itemNumber){
    let num = parseInt(itemNumber)
    const results = await FindFromParse("ApiProductVariants"+prodModelYear,[{"method":"equalTo","key":"itemNumber","value":num}]);
    if(results && results[0]){
      let product = await GetExternalProductInfo(results[0].attributes.slug,prodModelYear);
      return  product
    }
  } else{
    return null
  }
}

export const GetExternalProductInfo = async(slug,year) =>{
  let prodModelYear = year ? year : ModelYear;
  if(slug){
    let product = await GetFromParseBySlug('Products'+prodModelYear,slug);
    return product;
  } else{
    return null
  }
}

export const GetLocaleValue = () =>{
  let lang = window.lang;
  if(!lang){
    lang = "en";
  }
  return lang;
}

export const GetUserLocale = async() =>{
  let response = await Axios.get('https://alpine-hosports.herokuapp.com/getUserLocale');
  var country = response.data.geo.country.toLowerCase();
  let lang;
  var language =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;
  var languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
  if(country){
    if(country == "de"){
      lang='de'
    } else if(country == "gb"){
      lang='uk'
    } else if(country == "au"){
      lang='au'
    } else if(country == "ru"){
      lang='ru'
    } else if(country == "ca"){
      lang='ca-en'
    } else if(language.includes("fr")){
      lang='fr'
    } else{
      lang = 'en'
    }
  } else if(language){
    if(language.includes("ca-fr")){
      lang='ca-fr'
    } else if(language.includes("ca-en")){
      lang='ca-en'
    } else{
      lang = 'en'
    }
  }
  window.lang = lang;
  return lang
}

export const TruncateText = (text,length) => {
  let description = text;
  if(description){
    if(description.length > length){
      description = description.slice(0,length)+'...';
    }
  }
  return description
}

export const CapitalizeFirstLetter = (text) => {
  if(text){
    return text.charAt(0).toUpperCase() + text.slice(1);
  } else{
    return text
  }

}
